import React from 'react';
import Dashboard from './Dashboard';

const LandingPage = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default LandingPage;
